import React, { useState } from 'react';

const ServicesOverview = () => {
  const services = [
    {
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      ),
      title: 'Corporate Services',
      description: 'Complete corporate structuring and administrative support for multinational startups. We handle business registration, legal compliance, and corporate governance to establish strong foundations.',
      buttonText: 'Our programs',
      gradient: 'from-purple-500 to-indigo-600'
    },
    {
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
      title: 'Human Resource Management Services',
      description: 'Comprehensive HR solutions to build, manage, and retain exceptional talent across global markets. We handle recruitment, employee relations, and specialized human resources deployment (Accountants, HR Directors, Business Administrators, IT Administration etc).',
      buttonText: 'Meet the team',
      gradient: 'from-indigo-500 to-blue-600'
    },
    {
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      title: 'Accounting and Financial Management Services',
      description: 'Qualified accounting and financial management services to keep your start-up compliant and financially healthy. We provide bookkeeping, tax planning, and financial reporting across multiple regions in the world.',
      buttonText: 'Our services',
      gradient: 'from-blue-500 to-cyan-600'
    },
    {
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 4V2a1 1 0 011-1h8a1 1 0 011 1v2m0 0V3a2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5a2 2 0 012-2h1m12 0H5m7 4v6m-3-3h6" />
        </svg>
      ),
      title: 'Social Media Presence Management',
      description: 'Strategic social media presence management to amplify your brand and engage customers across international markets. We handle content strategy, multi-platform management, and growth optimization.',
      buttonText: 'Learn more',
      gradient: 'from-cyan-500 to-teal-600'
    },
    {
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2zM10 8h4m-4 4h4" />
        </svg>
      ),
      title: 'Co-working Spaces',
      description: 'We provide modern co-working environments that foster innovation and create networking opportunities for growing start-ups. We provide flexible office solutions, meeting rooms, and community events.',
      buttonText: 'Reserve space',
      gradient: 'from-teal-500 to-green-600'
    }
  ];

  return (
    <section className="py-32 relative overflow-hidden bg-slate-900">
      {/* Organic gradient on the right with animations */}
      <div className="absolute -top-20 -right-20 w-[800px] h-[800px]">
        <div 
          className="absolute top-20 right-0 w-[600px] h-[600px] bg-gradient-to-br from-purple-500/30 via-indigo-500/25 to-blue-500/20 rounded-full blur-3xl"
          style={{
            animation: 'floatSlow 10s ease-in-out infinite'
          }}
        ></div>
        <div 
          className="absolute top-60 right-40 w-[500px] h-[500px] bg-gradient-to-tl from-indigo-400/25 via-purple-400/20 to-violet-400/15 rounded-full blur-2xl"
          style={{
            animation: 'driftRight 12s ease-in-out infinite'
          }}
        ></div>
      </div>

      {/* Organic gradient on the bottom left with animations */}
      <div className="absolute -bottom-40 -left-40 w-[900px] h-[900px]">
        <div 
          className="absolute bottom-0 left-0 w-[700px] h-[700px] bg-gradient-to-br from-indigo-500/35 via-purple-500/25 to-violet-500/20 rounded-full blur-3xl"
          style={{
            animation: 'floatLeft 14s ease-in-out infinite'
          }}
        ></div>
        <div 
          className="absolute bottom-40 left-40 w-[600px] h-[600px] bg-gradient-to-tl from-purple-400/30 via-indigo-400/20 to-blue-400/15 rounded-full blur-2xl"
          style={{
            animation: 'driftLeft 8s ease-in-out infinite'
          }}
        ></div>
      </div>

      <div className="max-w-7xl mx-auto px-8 sm:px-12 lg:px-16 relative z-10">
        {/* Header */}
        <div className="mb-24">
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-AfacadFluxLight font-light text-white leading-tight max-w-5xl">
            We back founders from idea to seed - and beyond, goal after goal.
          </h2>
        </div>

        {/* Services Grid - 3 on top row, 2 on bottom row */}
        <div className="grid font-AfacadFluxLight grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16 lg:gap-20 mb-20">
          {services.slice(0, 3).map((service, index) => (
            <div key={index} className="space-y-6">
              {/* Icon */}
              <div className="text-purple-400 w-12 h-12">
                {service.icon}
              </div>
              
              {/* Content */}
              <div className="space-y-4">
                <h3 className="text-xl md:text-2xl font-semibold text-white leading-tight">
                  {service.title}
                </h3>
                <p className="text-base text-gray-300 leading-relaxed font-light">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom row with 2 services aligned with first 2 */}
        <div className="grid font-AfacadFluxLight grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16 lg:gap-20">
          {/* First service in position 1 */}
          <div className="space-y-6">
            {/* Icon */}
            <div className="text-purple-400 w-12 h-12">
              {services[3].icon}
            </div>

            {/* Content */}
            <div className="space-y-4">
              <h3 className="text-xl md:text-2xl font-semibold text-white leading-tight">
                {services[3].title}
              </h3>
              <p className="text-base text-gray-300 leading-relaxed font-light">
                {services[3].description}
              </p>
            </div>
          </div>

          {/* Second service in position 2 */}
          <div className="space-y-6">
            {/* Icon */}
            <div className="text-purple-400 w-12 h-12">
              {services[4].icon}
            </div>
            
            {/* Content */}
            <div className="space-y-4">
              <h3 className="text-xl md:text-2xl font-semibold text-white leading-tight">
                {services[4].title}
              </h3>
              <p className="text-base text-gray-300 leading-relaxed font-light">
                {services[4].description}
              </p>
            </div>
          </div>

          {/* Empty third column */}
          <div></div>
        </div>
      </div>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes floatSlow {
          0%, 100% {
            transform: translate(0px, 0px) rotate(0deg);
          }
          33% {
            transform: translate(80px, -100px) rotate(3deg);
          }
          66% {
            transform: translate(-60px, 60px) rotate(-2deg);
          }
        }

        @keyframes driftRight {
          0%, 100% {
            transform: translate(0px, 0px) scale(1);
          }
          25% {
            transform: translate(40px, -60px) scale(1.1);
          }
          50% {
            transform: translate(-32px, 32px) scale(0.88);
          }
          75% {
            transform: translate(48px, 40px) scale(1.06);
          }
        }

        @keyframes floatLeft {
          0%, 100% {
            transform: translate(0px, 0px) rotate(0deg);
          }
          33% {
            transform: translate(-72px, 88px) rotate(-3deg);
          }
          66% {
            transform: translate(100px, -72px) rotate(2.5deg);
          }
        }

        @keyframes driftLeft {
          0%, 100% {
            transform: translate(0px, 0px) scale(1);
          }
          25% {
            transform: translate(-48px, 64px) scale(1.12);
          }
          50% {
            transform: translate(32px, -40px) scale(0.84);
          }
          75% {
            transform: translate(-56px, -32px) scale(1.08);
          }
        }
      `}</style>
    </section>
  );
};

export default ServicesOverview; 